import React from 'react';
import {
  GoogleSheetsIcon,
  IconTypeProps,
  KlaviyoIcon,
  MailchimpIcon,
  SalesForceIcon,
  SendlaneIcon,
  SlackIcon,
  WebhookIcon,
  ShopifyIcon,
  ZapierIcon,
  GoHighLevelIcon,
} from '@mm/icons';
import { ReactComponent as AdWordIcon } from 'assets/adword.svg';
import { ReactComponent as FacebookIcon } from 'assets/facebook-circle.svg';
import { IntegrationTypes } from '@mm/state/model/ConnectionModel';
import classNames from 'classnames';

export const IntegrationIcon = ({
  integrationType,
  isActive,
  iconProps: outerIconProps,
  className,
}: {
  integrationType: IntegrationTypes;
  isActive: boolean;
  iconProps?: IconTypeProps;
  className?: string;
}) => {
  const activeIconsColors = {
    default: '#1890FF',
    mailchimp: '#000000',
    zapier: '#FA541C',
    google_spreadsheet: '#21A465  ',
    klaviyo: '#262626',
    sendlane: '#ff3c78',
    shopify: '#8cb83b',
  };

  if (!integrationType) {
    return <></>;
  }

  const type =
    integrationType === 'capi' ? 'facebook_ads_audience' : integrationType;

  const defaultIconProps = {
    color: isActive ? activeIconsColors[type] : '#8EA1B2',
    size: 20,
  };

  const iconProps = { ...defaultIconProps, ...outerIconProps };
  const classList = classNames('integration-icon', className, {
    'integration-icon__inactive': !isActive,
    'integration-icon__inactive-facebook': type === 'facebook_ads_audience',
    'integration-icon__inactive-highLevel': type === 'gohighlevel' && !isActive,
  });

  const componentsList = {
    default: <WebhookIcon {...iconProps} />,
    mailchimp: <MailchimpIcon {...iconProps} />,
    zapier: (
      <ZapierIcon
        style={{
          backgroundColor: isActive ? activeIconsColors[type] : '#8EA1B2',
        }}
        color="white"
        size={20}
      />
    ),
    google_spreadsheet: <GoogleSheetsIcon {...iconProps} />,
    klaviyo: <KlaviyoIcon {...iconProps} />,
    salesforce: <SalesForceIcon {...iconProps} />,
    sendlane: <SendlaneIcon {...iconProps} />,
    slack: <SlackIcon {...iconProps} />,
    shopify: <ShopifyIcon {...iconProps} />,
    gohighlevel: <GoHighLevelIcon className={classList} />,
    leadconnector: <GoHighLevelIcon className={classList} />,
    google_ads_audience: <AdWordIcon className={classList} />,
    facebook_ads_audience: <FacebookIcon className={classList} />,
  };

  return componentsList[type] || null;
};
